import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import styles from 'components/Container/Container.module.scss';
import React from 'react';
import classNames from 'classnames';

var Container = function Container(_ref) {
  var as = _ref.as,
      children = _ref.children,
      size = _ref.size,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, ["as", "children", "size", "className"]);

  var Element = {
    as: as
  };
  return /*#__PURE__*/React.createElement(Element.as, Object.assign({
    className: classNames(styles.container, styles[size], className)
  }, props), children);
};

Container.defaultProps = {
  size: 'xl',
  className: '',
  as: 'div'
};
export default Container;